import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import LicenseRenewalFailPoliceCaseBottomSheet from '@di-shared/features/public-service/license-renewal/LicenseRenewalFailPoliceCaseBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500;

export default function LicenseRenewalFailPoliceCaseBottomSheetPage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <LicenseRenewalFailPoliceCaseBottomSheet />
    </BottomSheetWebViewWrapper>
  );
}
